import { useMutation, useQueryClient } from 'react-query'
import { GET_PROVIDER_DETAILS_CACHE_KEY } from 'src/modules/booking/hooks/use-availability-slots'
import { GET_BOOKING_ONBOARDING_CACHE_KEY } from 'src/modules/user/hooks/use-booking-onboarding'
import { BookingOnboardingService } from 'src/services/booking-onboarding.service'
import { isRetryableSaveError, SAVE_RETRY_DELAY_MS } from './booking-branding-card.domain'

export function useSaveBookingBranding() {
  const queryClient = useQueryClient()

  return useMutation((formData: FormData) => BookingOnboardingService.saveBookingBranding(formData), {
    retry: (failureCount, error) => failureCount < 1 && isRetryableSaveError(error),
    retryDelay: SAVE_RETRY_DELAY_MS,
    onSuccess: () => {
      queryClient.invalidateQueries([GET_BOOKING_ONBOARDING_CACHE_KEY])
      // By prefix: booking pages key provider details by the route id, which may lack `usr_`.
      queryClient.invalidateQueries(GET_PROVIDER_DETAILS_CACHE_KEY)
    },
  })
}
